<div class="d-flex">
    @if (Functionalities.PlanningOverview | hasFunctionality: user) {
        <button
            class="planning-button"
            (click)="openPlanning($event)"
            (auxclick)="$event.button === 1 && openPlanning($event)"
            matTooltip="Planning"
            aria-label="Planning"
            [disabled]="!planning()"
            mat-icon-button
            color="primary">
            <mat-icon fontSet="fas" fontIcon="fa-calendar-days"></mat-icon>
        </button>
        <button
            class="planning-button"
            (click)="print()"
            (auxclick)="$event.button === 1 && print()"
            matTooltip="Afdrukken"
            aria-label="Afdrukken"
            [disabled]="!planning()"
            mat-icon-button
            color="primary">
            <mat-icon fontSet="fas" fontIcon="fa-print"></mat-icon>
        </button>
    }
    @if (Functionalities.DeclarationManagement | hasFunctionality: user) {
        <button
            class="planning-button override-disabled"
            (click)="goToProcessing($event)"
            (auxclick)="$event.button === 1 && goToProcessing($event)"
            matTooltip="Verwerken"
            aria-label="Verwerken"
            [disabled]="!dayReport()?.article_dayreports?.length"
            mat-icon-button
            color="primary">
            <mat-icon fontSet="fas" fontIcon="fa-list"></mat-icon>
        </button>
    }
</div>
